import React, { useEffect, useState, useRef } from "react";
import classes from "../style/Style.module.css";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import DexterCall from "../Images/UpdatedDexter-call.svg";
import {
  ROUTE_PLACEOF_BIRTH,
  ROUTE_EMAIL,
  ROUTE_ACCOUNT_TYPE,
  Gender_Dob_Verification,
  Address_Verification, ROUTE_NOMINEE_DETAILS,
  ROUTE_CHECKBOXES,
  ROUTE_UPDATED_PORT_FOLIO_SCREEN,
  ROUTE_MOBILE_VERIFICATION,
  ROUTE_NOMINEE_SENDOTP,
  ROUTE_DXTER_SCANNING, ROUTE_NRI_Address
} from "../Routes";
import { useNavigate } from "react-router-dom";
import Lock from "../Images/Lock.svg";
import axios from "../libs/axiosConfig";
import { useSelector } from "react-redux";
import { selectPhoneNumber } from "../Store/MobileSlice";
import Toast from "../Components/ToastMsg/Toast";
import { selectPanNumber } from "../Store/panNumberSlice";
import { ToastContainer } from "react-toastify";
import { selectRefreshToken } from "../Store/Token/refreshTokenSlice";
import Modal from "react-modal";
import LogoutModal from "../Components/LogoutModal";
import NewDexterLogo from "../Images/NewDexterLogo.svg";

const Occupationfinal = () => {
  const Navigate = useNavigate();
  const storedToken = useSelector((state) => state.storedToken.accessToken);
  const [formErrors, setFormErrors] = useState({});
  const [annualIncome, setannualIncome] = useState("");
  const [occupation, setoccupation] = useState("");
  const [suggestionsOccupation, setSuggestionsOccupation] = useState([]);
  // const [showSuggestionsOccupation,setShowSuggestionsOcupation] =
  //   useState(false);

  const [suggestionsIncome, setSuggestionsIncome] = useState([]);
  const [showSuggestionsIncome, setShowSuggestionsIncome] = useState(false);
  const [showSuggestionsOcupation, setShowSuggestionsOcupation] =
    useState(false);
  const phoneNumber = useSelector(selectPhoneNumber);
  const panNumber = useSelector(selectPanNumber);
  const refreshToken = useSelector(selectRefreshToken);
  const [showModal, setShowModal] = useState(false);
  const [apiCallsInProgress, setApiCallsInProgress] = useState(0);

  const [isLoading, setIsLoading] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (apiCallsInProgress > 0) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [apiCallsInProgress]);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowSuggestionsOcupation(false);
      setShowSuggestionsIncome(false);
    }
  };

  const occupations = [
    "Private Sector Service",
    "Public Sector / Government Service",
    "Government Service",
    "Business",
    "Retired",
    "Housewife",
    "Student",
    "Non-Government Service",
    "Service",
    "Professional",
    "Agriculturist",
    "Others",
    "Not Specified",
    "Profession - Engineering",
    "Profession - Finance",
    "Profession - Legal",
    "Profession - Medicine",
    "Forex Dealer",
    "Business Manufacturing",
    "Business Trading",
  ];
  const occupationscode = {
    "Private Sector Service": "41",
    "Public Sector / Government Service": "42",
    "Government Service": "2A",
    Business: "1",
    Retired: "5",
    Housewife: "6",
    Student: "7",
    "Non-Government Service": "2B",
    Service: "2",
    Professional: "3",
    Agriculturist: "4",
    Others: "8",
    "Not Specified": "9",
    "Profession - Engineering": "3C",
    "Profession - Finance": "3B",
    "Profession - Legal": "3D",
    "Profession - Medicine": "3A",
    "Forex Dealer": "43",
    "Business Manufacturing": "1A",
    "Business Trading": "1B",
  };

  const annualIncomes = [
    "Below 1 lakh",
    "1 to 5 Lacs",
    "5 to 10 Lacs",
    "10 to 25 Lacs",
    "25 Lacs to 1 Crore",
    "Above 1 Crore",
  ];

  const annualIncomesCodes = {
    "Below 1 lakh": "31",
    "1 to 5 Lacs": "32",
    "5 to 10 Lacs": "33",
    "10 to 25 Lacs": "34",
    "25 Lacs to 1 Crore": "35",
    "Above 1 Crore": "36",
  };
  const mappedAnnualIncomes = {
    "Below 1 lakh": "Below 1 Lakh",
    "1 to 5 Lacs": "> 1 <=5 LACS",
    "5 to 10 Lacs": ">5 <=10 LACS",
    "10 to 25 Lacs": ">10 <= 25 Lacs",
    "25 Lacs to 1 Crore": "> 25 LACS < = 1 CRORE",
    "Above 1 Crore": "ABOVE 1 CRORE",
  };

  const mapAnnualIncome = (selectedIncome) => {
    return mappedAnnualIncomes[selectedIncome];
  };
  const mappedIncome = mapAnnualIncome(annualIncome);

  const handleoccupationChange = (e) => {
    const input = e.target.value;
    const alphabetsOnly = /^[A-Za-z\s]+$/;

    if (alphabetsOnly.test(input) || input === "") {
      setoccupation(input);

      const filteredSuggestions = occupations.filter(
        (item) =>
          item.toLowerCase().startsWith(input.toLowerCase()) &&
          item.toLowerCase() !== input.toLowerCase()
      );

      setSuggestionsOccupation(filteredSuggestions);
      setShowSuggestionsOcupation(true);
    }
  };

  const handleannualIncomeChange = (e) => {
    const input = e.target.value;
    const alphabetsOnly = /^[A-Za-z\s]+$/;

    if (alphabetsOnly.test(input) || input === "") {
      setannualIncome(input);

      const filteredSuggestions = annualIncomes.filter(
        (item) =>
          item.toLowerCase().startsWith(input.toLowerCase()) &&
          item.toLowerCase() !== input.toLowerCase()
      );

      setSuggestionsIncome(filteredSuggestions);
      setShowSuggestionsIncome(true);
    }
  };

  const handleoccupationShow = () => {
    if (occupation !== "") {
      setoccupation("");
      setSuggestionsOccupation(occupations);
      setShowSuggestionsOcupation(true);
    } else {
      const filteredSuggestions = occupations.filter(
        (item) =>
          item.toLowerCase().startsWith(occupation.toLowerCase()) &&
          item.toLowerCase() !== occupation.toLowerCase()
      );

      setSuggestionsOccupation(filteredSuggestions);
      setShowSuggestionsOcupation(
        (prevShowSuggestions) => !prevShowSuggestions
      );
      setShowSuggestionsIncome(false);
    }
  };

  const handleannualIncomeShow = () => {
    if (annualIncome !== "") {
      setannualIncome("");
      setSuggestionsIncome(annualIncomes);
      setShowSuggestionsIncome(true);
    } else {
      const filteredSuggestions = annualIncomes.filter(
        (item) =>
          item.toLowerCase().startsWith(annualIncome.toLowerCase()) &&
          item.toLowerCase() !== annualIncome.toLowerCase()
      );

      setSuggestionsIncome(filteredSuggestions);
      setShowSuggestionsIncome((prevShowSuggestions) => !prevShowSuggestions);
      setShowSuggestionsOcupation(false);
    }
  };

  const handleSuggestionClick = (selectedOccupation) => {
    setoccupation(selectedOccupation);
    setSuggestionsOccupation([]);
    setShowSuggestionsOcupation(false);

    console.log(
      "Selected Occupation Code:",
      occupationscode[selectedOccupation]
    );
  };
  const handleAnnualIncomeClick = (selectedIncome) => {
    setannualIncome(selectedIncome);
    setSuggestionsIncome([]);
    setShowSuggestionsIncome(false);

    console.log(
      "Selected Annual Income Code:",
      annualIncomesCodes[selectedIncome]
    );
  };

  const HandleBack = () => {
    setShowModal(true);
  };

  const handleLogoutConfirm = () => {
    Navigate(ROUTE_MOBILE_VERIFICATION);
  };

  const HandleSubmit = async () => {

    try {
      setApiCallsInProgress(apiCallsInProgress + 1);
      const headers = {
        Authorization: `Bearer ${storedToken}`,
        // RefreshToken: refreshToken,
      };

      // Make a POST request to the first API endpoint
      const firstapi =
        "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";
      const requestBody = {
        CustomerKycDetails: {
          request_type: "post",
          mobileNumber: phoneNumber,
          pan: panNumber,
          nseIncomeCode: annualIncomesCodes[annualIncome],
          nseIncomeCodeDescription: mappedIncome,
          nseOccupationCode: occupationscode[occupation],
          nseOccupationCodeDescription: occupation,
        },
      };

      const response = await axios.post(firstapi, requestBody, { headers });
      console.log("First API Response:", response.data);


      if (response.status === 200) {
        const thirdapi =
          "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";
        const thirdRequestBody = {
          CustomerKycDetails: {
            request_type: "get",
            mobileNumber: phoneNumber,
            pan: panNumber,
          },
        };

        const thirdResponse = await axios.post(thirdapi, thirdRequestBody, {
          headers,
        });

        // const customerKycApiResponse = await axios.get(
        //   "https://partnerapp.ambrela.money/api/GetCustomerKycDetails",

        //   {
        //     headers: {
        //       Authorization: `Bearer ${storedToken}`,
        //       // RefreshToken: refreshToken,
        //     },
        //   }
        // );
        if (
          thirdResponse.data.statusCode === 200 &&
          thirdResponse.data.status === true

        ) {
          const { bankVerified, nomineeVerified } = thirdResponse.data.body;
          setApiCallsInProgress(apiCallsInProgress - 1);

          if (
            thirdResponse.data.body.emailId === ""

          ) {
            Navigate(ROUTE_EMAIL);
          } else if (
            thirdResponse.data.body.bankAccountNumber === "" ||

            thirdResponse.data.body.bankIfscCode === "" ||

            thirdResponse.data.body.bankAccountType === "" ||

            thirdResponse.data.body.bankName === "" ||

            thirdResponse.data.body.bankBranchName === "" ||

            thirdResponse.data.body.bankBranchAddress === "" ||

            thirdResponse.data.body.bankCodeNSE === "" ||

            thirdResponse.data.body.bankCodeBillDesk === "" ||

            thirdResponse.data.body.bankAccountHolderName === ""

          ) {
            Navigate(ROUTE_ACCOUNT_TYPE);
          } else if (
            (thirdResponse.data.body.bankAccountNumber !== "" ||

              thirdResponse.data.body.bankIfscCode !== "" ||

              thirdResponse.data.body.bankAccountType !== "" ||

              thirdResponse.data.body.bankName !== "" ||

              thirdResponse.data.body.bankBranchName !== "" ||

              thirdResponse.data.body.bankBranchAddress !== "" ||

              thirdResponse.data.body.bankCodeNSE !== "" ||

              thirdResponse.data.body.bankCodeBillDesk !== "" ||

              thirdResponse.data.body.bankAccountHolderName !== "" ||

              null) &&
            (thirdResponse.data.body.bankVerified.account_exists !== "True" ||
              thirdResponse.data.body.bankVerified.message !== "success")
          ) {
            Navigate(ROUTE_ACCOUNT_TYPE);
          } else if (
            thirdResponse.data.body.panDetails.gender === "" ||

            thirdResponse.data.body.panDetails.title === "" ||

            thirdResponse.data.body.panDetails.dob === ""

          ) {
            Navigate(Gender_Dob_Verification);
          } else if (
            thirdResponse.data.body.panDetails.addr1 === "" ||


            thirdResponse.data.body.panDetails.addr2 === "" ||

            thirdResponse.data.body.panDetails.city === "" ||

            thirdResponse.data.body.panDetails.state === "" ||

            thirdResponse.data.body.panDetails.pincode === "" ||

            thirdResponse.data.body.panDetails.country === "" ||

            thirdResponse.data.body.panDetails.fullAddress === ""

          ) {
            Navigate(Address_Verification);
          } else if (
            thirdResponse.data.body.placeOfBirth === "" ||

            thirdResponse.data.body.nseCountryCodeOfBirth === "" ||

            thirdResponse.data.body.nseCountryOfBirth === ""

          ) {
            Navigate(ROUTE_PLACEOF_BIRTH);
          } else if (
            thirdResponse.data.body.politicallyExposedPerson === "" ||

            null ||
            thirdResponse.data.body.relatedToPoliticallyExposedPerson === ""

          ) {
            Navigate(ROUTE_CHECKBOXES);
          } else if (
            ((thirdResponse.data.body.nomineeDob !== ""
            ) &&
              thirdResponse.data.body.nomineeName === "")

          ) {

            Navigate(ROUTE_NOMINEE_DETAILS);
          } else if (
            ((thirdResponse.data.body.nomineeName !== ""
            ) &&
              thirdResponse.data.body.nomineeDob === "")

          ) {

            Navigate(ROUTE_NOMINEE_DETAILS);
          } else if (
            (thirdResponse.data.body.nomineeName !== "" &&
              thirdResponse.data.body.nomineeType !== "" &&
              thirdResponse.data.body.nomineeRelationShip !== "" &&
              thirdResponse.data.body.nomineeDob !== ""
            ) &&
            (thirdResponse.data.body.nomineeVerified === "N"
            )
          ) {
            console.log("first");
            Navigate(ROUTE_NOMINEE_SENDOTP);
          }
         
          else {
            const requestBody = {
              dexterrCustomerBasicQuestions: {
                mobile_no: phoneNumber,
                request_type: "get",
                country_code: "+91",
              }
            };
            const headers = {
              Authorization: `Bearer ${storedToken}`,
              // RefreshToken: refreshToken
            };

            const secondApiResponse = await axios.post("https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc", requestBody, {
              headers: headers
            });
            if (secondApiResponse.data.data.resident !== "Resident Indian") {
              Navigate(ROUTE_NRI_Address)
            }

            else {
              Navigate(ROUTE_DXTER_SCANNING);
            }
          }
        } else {
          Toast.error(
            thirdResponse.data.message + " " + thirdResponse.data.errorMessage
          );
          setApiCallsInProgress(apiCallsInProgress - 1);

          // console.log("1")
        }
      }
      else {
        setApiCallsInProgress(apiCallsInProgress - 1);

        Toast.error("Error");
      }
    } catch (error) {
      setApiCallsInProgress(apiCallsInProgress - 1);

      Toast.error(
        error.response.data.errorMessage + " " + error.response.data.message ||
        "Error"
      );
    }
  };

  return (
    <div className="Occupation_Container">
      <div className="Occupation_Header">
        <ArrowBackIosIcon className="Back_btn" onClick={HandleBack} />
        <div className="Dexter_logo_container">
          <img alt="" src={NewDexterLogo} className="DexterLogo" />
        </div>
      </div>
      <div className="Occupation_Div_Container" ref={dropdownRef}>
        <p className="occupation_Input_Heading_text">Occupation details</p>
        <span className="Input_Sub_heading">
          Tell us about your professional background <br />
        </span>
        <div className="Regulatory_Requirement_Container">
          <img alt="Lock-img" src={Lock} />
          <span className="Regulatory_Requirement_Text">
            Regulatory requirement
          </span>
        </div>
        {/* Nominee Name Input */}
        <div className="Input_Filed_Box">
          <span className="Enter_occupaiion_text">Occupation</span>
          <div className="Input_Inner_Container">
            <input
              className={`${classes.Input_Filed} ${formErrors.ifscCode ? classes.Error : ""
                }`}
              value={occupation}
              onChange={handleoccupationChange}
              onBlur={() => setShowSuggestionsOcupation(true)}
            />

            <button
              className={classes.DropDown_button}
              onClick={handleoccupationShow}
            />
          </div>
          {showSuggestionsOcupation && (
            <div className={classes.Suggestions_Container}>
              {suggestionsOccupation.map((suggestion1, index1) => (
                <div
                  key={index1}
                  className={classes.Suggest_Suggestion}
                  onClick={() => handleSuggestionClick(suggestion1)}

                >
                  {suggestion1}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Nominee Date of Birth Input */}
        <div className="Input_Filed_Box2">
          <span className="Enter_occupaiion_text2">Annual Income</span>
          <div className="Input_Inner_Container2">
            <input
              className={`${classes.Input_Filed} ${formErrors.ifscCode ? classes.Error : ""
                }`}
              value={annualIncome}
              onChange={handleannualIncomeChange}
              onBlur={() => setShowSuggestionsIncome(true)}
            />
            <button
              className={classes.DropDown_button}
              onClick={handleannualIncomeShow}
            />
          </div>
          {showSuggestionsIncome && (
            <div className={classes.Suggestions_Container} >
              {suggestionsIncome.map((suggestion, index) => (
                <div
                  key={index}
                  className={classes.Suggest_Suggestion}
                  onClick={() => handleAnnualIncomeClick(suggestion)}
                >
                  {suggestion}
                </div>
              ))}
            </div>
          )}
        </div>

        <button className="Submit_button" onClick={HandleSubmit}>
          {" "}
          Submit{" "}
        </button>
      </div>
      {isLoading && (
        <div className={classes.overlay}>
          <div className={classes.loading_text}>Please Wait...</div>
        </div>
      )}
      <ToastContainer />
      <LogoutModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleLogoutConfirm}
      />
    </div>
  );
};

export default Occupationfinal;
